<template>
  <div class="container">

   <Formulario/>
 </div>
</template>


<script>

import Formulario from './partes/Formulario'


export default {
  name: 'Inicio',
  components:{
    Formulario
  },
  data () {
    return {
      // msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>



// WEBPACK FOOTER //
// src/components/inicio.vue